import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "./utils/Context";

ReactDOM.createRoot(document.getElementById("root")).render(
  <UserProvider>
    <App />
  </UserProvider>
);
